export default "__VITE_ASSET__Bu42xkCT__"